"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Discount = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const uuid_1 = require("uuid");
const graphql_1 = require("../graphql");
const orm_1 = require("../orm");
let Discount = class Discount extends orm_1.CDBaseEntity {
    constructor() {
        super(...arguments);
        this._id = (0, uuid_1.v4)();
        this.price = 0;
        this.fee = 0;
        this.description = "";
    }
};
exports.Discount = Discount;
__decorate([
    (0, orm_1.CDObjectIdColumn)(),
    (0, graphql_1.GField)(),
    (0, class_validator_1.IsUUID)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Discount.prototype, "_id", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, graphql_1.GField)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Discount.prototype, "price", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, graphql_1.GField)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Discount.prototype, "fee", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.DiscountType),
    __metadata("design:type", Number)
], Discount.prototype, "type", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Discount.prototype, "description", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, graphql_1.GField)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Discount.prototype, "priceDiscountCoefficient", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, graphql_1.GField)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Discount.prototype, "feeDiscountCoefficient", void 0);
exports.Discount = Discount = __decorate([
    (0, orm_1.CDEntity)("discounts"),
    (0, graphql_1.GObjectType)("Discount")
], Discount);
//# sourceMappingURL=Discount.js.map